import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">麻豆cm传媒</span>
            </div>
            <p className="text-sm text-background-50/60 leading-relaxed">
              麻豆cm传媒在线高清为您提供最新高清视频内容，画质清晰流畅，海量资源免费在线观看。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/action" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">动作大片</Link>
              <Link to="/category/drama" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">剧情精选</Link>
              <Link to="/category/comedy" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧搞笑</Link>
              <Link to="/category/scifi" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap">科幻奇幻</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系方式</h4>
            <div className="flex flex-col gap-2.5 text-sm text-background-50/60">
              <p>邮箱：contact@madoucm.com</p>
              <p>客服热线：400-888-9999</p>
              <p>工作时间：周一至周日 9:00-21:00</p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 麻豆cm传媒在线高清 版权所有 | 保留所有权利
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}